import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as CartActions from './cart.actions';
import { ItemsService } from "src/app/items/items.service";
import { concatMap, distinctUntilChanged, map, mergeMap, switchMap, tap } from "rxjs/operators";
import { CartState } from "./cart.reducers";
import { Store } from "@ngrx/store";

@Injectable()
export class CartEffects {
    constructor(
        private actions$: Actions,
        private is: ItemsService,
        private store: Store<CartState>
    ) {}

    getItemsByCode$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(CartActions.getItemsByCode),
            mergeMap(action => this.is.getItemsByCode(action.code).pipe(
                // map(items => this.store.dispatch(CartActions.itemSearchSuccess({items})) )
                map(items => CartActions.itemSearchSuccess({items})),
                // distinctUntilChanged(),
                // tap(items => console.warn('items in effects: ', items)),
            ))
        );
    });
}